import React, { useEffect } from "react"
import { Tab, Tabs } from "react-bootstrap"
import { StockLocationTabProps } from "../../common/types"
import { useDispatch, useSelector } from "react-redux"
import { InventoryLocationSelector } from "../../state/inventory/location/selectors"
import { InventoryLocationAction } from "../../state/inventory/location/actions"

export const StockLocationTabs = (props: StockLocationTabProps) => {
    const locationListing = useSelector(InventoryLocationSelector.getListing)
    const dispatch = useDispatch()
    const {activeTab, onTabChangeCallback} = props

    useEffect(() => {
        if (locationListing.length === 0) {
            dispatch(InventoryLocationAction.fetchListing())
        }
    }, [])

    const onTabChange = (key: string | null) => {
        onTabChangeCallback(key)
    }

    if (!activeTab && locationListing.length > 0) {
        onTabChangeCallback(locationListing[0].id)
        return <></>
    }

    if (!activeTab) {
        return <></>
    }

    return (
        <>
            <Tabs
                activeKey={activeTab}
                onSelect={onTabChange}>
                {locationListing.map(loc => <Tab key={loc.id} eventKey={loc.id} title={loc.name}/>)}
            </Tabs>
        </>
    )
}


// WEBPACK FOOTER //
// ./src/inventory/components/StockLocationTabs.tsx